import apiService from './api';
import {
  CustomerPayment,
  CreatePaymentData,
  UpdatePaymentData,
  PaymentFilters,
  OutstandingInvoice,
  PaymentSummary
} from '../types/paymentTypes';

class PaymentService {
  async getPayments(filters?: PaymentFilters): Promise<CustomerPayment[]> {
    const params = new URLSearchParams();
    if (filters?.customer_id) params.append('customer_id', filters.customer_id.toString());
    if (filters?.payment_method) params.append('payment_method', filters.payment_method);
    if (filters?.date) params.append('date', filters.date);

    const response = await apiService.get<CustomerPayment[]>(
      `/orders/payments${params.toString() ? `?${params.toString()}` : ''}`
    );
    return response.data;
  }

  async getPaymentById(id: string): Promise<CustomerPayment> {
    const response = await apiService.get<CustomerPayment>(
      `/orders/payments/${id}`
    );
    return response.data;
  }

  async createPayment(data: CreatePaymentData): Promise<CustomerPayment> {
    const response = await apiService.post<CustomerPayment>(
      '/orders/payments',
      data
    );
    return response.data;
  }

  async updatePayment(data: UpdatePaymentData): Promise<CustomerPayment> {
    const { id, ...updateData } = data;
    const response = await apiService.put<CustomerPayment>(
      `/orders/payments/${id}`,
      updateData
    );
    return response.data;
  }

  async deletePayment(id: string): Promise<void> {
    await apiService.delete(`/orders/payments/${id}`);
  }

  async allocatePayment(paymentId: string, invoiceId: number, amount: number): Promise<void> {
    await apiService.post(`/orders/payments/${paymentId}/allocate`, {
      invoice_id: invoiceId,
      allocated_amount: amount
    });
  }

  async getOutstandingInvoices(customerId: number): Promise<OutstandingInvoice[]> {
    const response = await apiService.get<OutstandingInvoice[]>(
      `/orders/customers/${customerId}/outstanding`
    );
    return response.data;
  }

  async getPaymentSummary(customerId: number): Promise<PaymentSummary> {
    const response = await apiService.get<PaymentSummary>(
      `/orders/customers/${customerId}/payment-summary`
    );
    return response.data;
  }
}

export const paymentService = new PaymentService();
export default paymentService;